import { ICellPopover } from '@hooks/useCellPopover';
import { Paper, PopoverProps, Popper } from '@material-ui/core';
import React from 'react';

export type CellPopoverProps<T extends object> = Omit<PopoverProps, "open" | "onClose" | "anchorEl"> & {
    cellPopover: ICellPopover<T>
}

export function CellPopover<T extends object>({ cellPopover, children, ...props }: CellPopoverProps<T>) {
    return (
        <Popper
            open={cellPopover.isOpened}
            anchorEl={cellPopover.anchorEl}
            placement="left"
            disablePortal={false}
            modifiers={{
                flip: {
                    enabled: true,
                },

                preventOverflow: {
                    enabled: true,
                    boundariesElement: 'scrollParent',
                },

                arrow: {
                    enabled: true,
                    element: cellPopover.anchorEl
                }
            }}
            style={{
                pointerEvents: 'none',
                maxWidth: '90%'
            }}
        ><Paper elevation={15}>{children}</Paper></Popper>
    )
}